import { render, staticRenderFns } from "./vipCardList.vue?vue&type=template&id=f045d824&scoped=true&"
import script from "./vipCardList.vue?vue&type=script&lang=js&"
export * from "./vipCardList.vue?vue&type=script&lang=js&"
import style0 from "./vipCardList.vue?vue&type=style&index=0&id=f045d824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f045d824",
  null
  
)

export default component.exports